/**
 * @voltxampere/ui — LoadCircuitCommand (Sprint 16)
 *
 * Replace the entire current circuit with an imported one. Used by
 * Sprint 16's SPICE import dialog: parsing produces a fresh
 * `Circuit`, the user confirms, and the active document is swapped
 * via the shared `undoStack`. A single Cmd+Z reverts the import.
 *
 * Snapshot strategy: `do(prev)` stores `prev` in a private field
 * and returns the new circuit; `undo(prev)` returns the stored
 * snapshot. The Sprint 13 immutable-circuit invariant is preserved
 * — we never mutate either side.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class LoadCircuitCommand {
    nextCircuit;
    description;
    snapshot = null;
    constructor(nextCircuit, description = "Devre içe aktarıldı") {
        this.nextCircuit = nextCircuit;
        this.description = description;
    }
    do(circuit) {
        this.snapshot = circuit;
        return this.nextCircuit;
    }
    undo(_circuit) {
        if (this.snapshot === null) {
            // Idempotent guard — if `do` was never called we have no
            // baseline to restore. Returning the current circuit is
            // safer than throwing inside an undo handler.
            return _circuit;
        }
        return this.snapshot;
    }
    describe() {
        return this.description;
    }
}
//# sourceMappingURL=load-circuit.js.map